import React from 'react'
import Home from '../Pages/Home'
import Header from '../Components/Header'
import Footer from '../Components/Footer'
import ImageGrid from '../Components/aboutsection/ImageGrids'
import LearnSection from '../Components/homesection/LearnSection'
import Testimonials from '../Components/homesection/Testimonials'
import Cards from '../Components/homesection/Cards'
import Banner from '../Components/homesection/Banner'
import DrawBanner from '../Components/homesection/DrawBanner' 

function HomeLayout() {
  return (

    <>
    <Header />
    <DrawBanner />
    <Home />
    {/* <ImageGrid /> */}
    <Cards />
    <LearnSection />
    <Banner />
    <Testimonials />
    <Footer />
    </>
  )
}

export default HomeLayout